var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIsrael(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0248 13.3728H18.0084L16.0003 9.89453L13.9922 13.3728H9.97569L11.9841 16.851L9.97569 20.3293H13.9922L16.0003 23.8075L18.0084 20.3293H22.0248L20.0164 16.851L22.0248 13.3728ZM18.4674 16.851L17.2339 18.9878H14.7668L13.5331 16.851L14.7667 14.7143H17.2339L18.4674 16.851ZM16.0003 12.5775L16.4594 13.3727H15.5413L16.0003 12.5775ZM12.2994 14.7143H13.2176L12.7585 15.5095L12.2994 14.7143ZM12.2994 18.9878L12.7586 18.1925L13.2177 18.9878H12.2994ZM16.0003 21.1245L15.5412 20.3293H16.4594L16.0003 21.1245ZM19.7011 18.9878H18.7829L19.2421 18.1925L19.7011 18.9878ZM18.7829 14.7143H19.7011L19.242 15.5095L18.7829 14.7143Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9601 4.3291H6.04045C4.58026 5.4921 3.32801 6.90473 2.34863 8.50304H29.6519C28.6724 6.90479 27.4202 5.4921 25.9601 4.3291Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04045 29.3727H25.96C27.4202 28.2097 28.6724 26.797 29.6518 25.1987H2.34863C3.32807 26.797 4.58032 28.2097 6.04045 29.3727Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIsrael);
export default __webpack_public_path__ + "static/media/flag_israel.2287c859360f5ad8e8648d7bd1d0a32e.svg";
export { ForwardRef as ReactComponent };